/**
 * 반응형 디바이스 브레이크포인트 상수
 */

/**
 * 디바이스 타입 (문자열)
 */
export const DEVICE_TYPE = {
    TABLET: "TABLET",
    LAPTOP: "LAPTOP",
    DESKTOP: "DESKTOP",
    DEFAULT: "DEFAULT",
};

/**
 * 디바이스별 브레이크포인트 (px)
 *
 * - TABLET: 0 ~ 1024px
 * - LAPTOP: 1025 ~ 1440px
 * - DESKTOP: 1441 ~ 1920px
 * - DEFAULT: 1921px+
 */
export const DEVICE_BREAKPOINT = {
    TABLET: 1024,
    LAPTOP: 1440,
    DESKTOP: 1920,
    DEFAULT: 2160,
};

/**
 * 디바이스 코드 (숫자)
 */
export const DEVICE_CODE = {
    TABLET: 3,
    LAPTOP: 2,
    DESKTOP: 1,
    DEFAULT: 0,
};
